// extracted by mini-css-extract-plugin
module.exports = {"pageFooterContainer":"StepFooter_pageFooterContainer__3lh4c","pageFooterSymbol":"StepFooter_pageFooterSymbol__3_bMx","pageFooterItem":"StepFooter_pageFooterItem__3R9SX"};